"use strict";
var _uppercasePattern = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(_uppercasePattern, "-$1").toLowerCase();
}
module.exports = hyphenate;
